module.exports = __webpack_public_path__ + "static/media/bellx2.f5768095.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/bellx2.mp3
// module id = 36
// module chunks = 0